__turbopack_context__.v({
  "content": "Jq22CW_content",
  "placeholder": "Jq22CW_placeholder",
  "placeholder-text": "Jq22CW_placeholder-text",
  "search-bar": "Jq22CW_search-bar",
  "search-input-wrapper": "Jq22CW_search-input-wrapper",
  "search-item": "Jq22CW_search-item",
  "search-item-wrapper": "Jq22CW_search-item-wrapper",
  "search-list": "Jq22CW_search-list",
  "selected": "Jq22CW_selected",
  "thumbnail": "Jq22CW_thumbnail",
});
